function parseFloatWithPrecision(value, precision) {
    let stringified = value.toString();
    let decimalPos = stringified.indexOf('.');
    if (decimalPos !== -1) {
        const decimalLength = stringified.length - decimalPos - 1;
        if (decimalLength < precision) {
            precision = decimalLength;
        }
    } else {
        precision = 0;
    }
    return parseFloat(value).toFixed(precision);
}

export {parseFloatWithPrecision};
